import { getRoute, getRouteDataByUrl, path } from '@/routes/Routes.helpers';
import { getFormattedPathName } from '@/helpers/utils';
import { BackLinks } from '@/components/widgets/HeaderWidget/HeaderWidget.types';

const getRouteLabel = (pathSegment: string): string => {
    if (!pathSegment) {
        return '';
    }

    const route = getRouteDataByUrl(`/${pathSegment}`);
    return route?.label || pathSegment;
};

export const getLinks = (
    pathnameRaw?: string | null,
    customLabel?: string,
): BackLinks | null => {
    if (!pathnameRaw) {
        return null;
    }

    const formatedPathName = getFormattedPathName(pathnameRaw);
    const pathnameAuth =
        pathnameRaw === path('authTg') ? pathnameRaw.slice(1) : '';
    const slicedPathname = formatedPathName.split('/').filter(Boolean);
    const hiddenRoutes = ['home', 'outfits', 'planer', 'suitcases', 'wardrobe'];

    if (hiddenRoutes.some((route) => formatedPathName === path(route))) {
        return null;
    }

    if (slicedPathname.length === 0) {
        return null;
    }

    const label =
        customLabel ||
        getRouteLabel(pathnameAuth) ||
        getRouteDataByUrl(formatedPathName)?.label ||
        getRouteLabel(slicedPathname[0]) ||
        slicedPathname.at(-1) ||
        '';

    let previousLink = null;

    if (slicedPathname.length > 1) {
        previousLink = `/${slicedPathname.slice(0, -1).join('/')}`;
    }

    return { archiveRoute: getRoute('home'), prevLink: previousLink, label };
};
